<template>
    <div>
        <div class="announcement-box" style="margin-bottom: 16px; background-color: #f6d0d2; padding: 16px; border: 1px solid #f5c6cb; border-radius: 4px;">
            <p>Please submit all new port requests to our 
                <a href="https://app.porting.com/#/Login">new portal</a>.
            </p>
            <p>If you have not registered in the new portal yet, sign up 
                <a href="https://app.porting.com/#/Signup">here</a>
            </p>
            <p>Use your existing login below to follow up on existing port orders only</p>
        </div>

        <el-form :model="loginForm" ref="loginForm"
                 class="loginForm md-layout md-alignment-center-center">
            <md-card class="md-layout-item">
                <md-card-header>
                    <div class="md-title">Account Login</div>
                </md-card-header>
                <md-card-content>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                            <md-field id="username" required>
                                <label for="username">Username</label>
                                <md-input v-model="loginForm.username" name="username" @keyup.enter="LogIn()"></md-input>
                            </md-field>
                        </div>
                    </div>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                            <md-field id="password" required>
                                <label for="password">Password</label>
                                <md-input v-model="loginForm.password" name="password" type="password" @keyup.enter="LogIn()"></md-input>
                            </md-field>
                        </div>
                    </div>
                </md-card-content>
                <md-card-actions style="padding: 0px 16px 16px;">
                    <el-button class="md-primary md-raised md-layout-item md-alignment-center-center"
                               @click="LogIn()"
                               :loading="executing_login"
                               type="primary"
                    >Log In
                    </el-button>
                </md-card-actions>
                <div><el-button type="text" class="forgot_password" @click="ForgotPassword">Forgotten your password?</el-button></div>
            </md-card>
        </el-form>

    </div>
</template>

<script>

    import {mapState} from "vuex";
    import {DEFAULT_EMAIL, DOMAIN_OVERRIDES} from "@/components/utils/constants";

    export default {
        name: "LoginView",
        data() {
            return {
                loginForm: {
                    username: '',
                    password: ''
                },
                email: (DOMAIN_OVERRIDES[window.location.host] && DOMAIN_OVERRIDES[window.location.host].email)
                    || DEFAULT_EMAIL,
            }
        },
         computed: {
            ...mapState({
                executing_login: state => state.auth.executing_login
            }),
        },
        methods: {
            LogIn: async function () {
                let payload = {
                    'username': this.loginForm.username,
                    'password': this.loginForm.password,
                }
                this.$store.dispatch('auth/login', payload)
                    .then(() => (this.$route.query.redirect) ? this.$router.push(this.$route.query.redirect) : this.$router.push('/'))
                    .catch(err => {
                        if (err.name === "NavigationDuplicated") {
                            return;
                        }
                        this.$notify({
                            title: 'Error',
                            message: 'Incorrect username or password',
                            type: 'error'
                        });
                    })
            },
            ForgotPassword: function () {
                this.$router.push('/forgot_password');
            }
        }
    };
</script>

<style scoped>
    form {
        display: inline-block;
        float: none;
        height: 200px;
        position: relative;
        top: 50%;
        -ms-transform: translateY(50%);
        transform: translateY(50%);
    }

    .contact_us {
        padding-top: 15px;
        padding-bottom: 60px;
        font-weight: 500;
    }

    .forgot_password {
        padding-bottom: 25px;
        font-weight: 300;
    }

</style>

